import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Dropdown, Table, Icon, Checkbox, Dimmer, Loader, Message } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { fetchTasks } from '~/task/actions'
import moment from 'moment'
import TaskAdd from '~/task/views/add'
import TaskEdit from '~/task/views/edit'

class OrderTasks extends Component {
  componentDidMount = () => {
    let { fetchTasks, order } = this.props
    fetchTasks({
      order_id: order.get('id'),
    })
  }

  render() {
    let { tasks, tasksLoading, tasksError, addTask, editTask, order, adding, editing } = this.props
    tasks = tasks.filter(t => t.get('order_id') === order.get('id'))

    let editingTask = editing ? tasks.find(t => t.get('id') === editing) : false

    return (
      <div className="order-tasks">
        <Table selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="Aihe" />
              <Table.HeaderCell content="Vastuuhenkilö" />
              <Table.HeaderCell content="Määräaika" />
              <Table.HeaderCell content="Status" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {tasks.size ? (
              tasks.map(task => {
                let id = task.get('id')
                let status = task.get('status')
                let deadline = moment(task.get('deadline'), 'YYYY-MM-DD HH:mm:ss.SSSZZ')
                let statusColor = 'default'

                if (status === 'working') statusColor = 'info'

                if (status === 'completed') statusColor = 'success'

                let late = moment().isAfter(deadline)

                if (late && status !== 'completed') statusColor = 'error'

                return (
                  <Table.Row key={id} error={statusColor === 'error'}>
                    <Table.Cell>
                      <span className={`status status--${statusColor}`} />
                      <button className="button-plain" onClick={e => e.preventDefault() & editTask(id)}>
                        {task.getIn(['data', '_task', 'icon']) ? (
                          <Icon name={task.getIn(['data', '_task', 'icon'])} />
                        ) : null}
                        {task.getIn(['data', 'subject']) || task.getIn(['data', '_task', 'name']) || '(Aihe puuttuu)'}
                      </button>
                    </Table.Cell>
                    <Table.Cell>{task.getIn(['user', 'name'])}</Table.Cell>
                    <Table.Cell>
                      {deadline.format('DD.MM.YYYY - HH:mm')}{' '}
                      {task.getIn(['data', 'duration']) ? <span>Kesto {task.getIn(['data', 'duration'])}</span> : null}
                    </Table.Cell>
                    <Table.Cell>{task.get('status')}</Table.Cell>
                  </Table.Row>
                )
              })
            ) : (
              <Table.Row>
                <Table.Cell colSpan="4">Tehtäviä ei ole asetettu.</Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="6" textAlign="left">
                <button className="button-plain" onClick={e => e.preventDefault() & addTask()}>
                  Lisää tehtävä
                </button>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
        {editingTask ? (
          <TaskEdit order={order} task={editingTask} task_type_id="HJe9wtomQ" onClose={() => editTask(false)} />
        ) : adding ? (
          <TaskAdd order={order} onClose={() => addTask(false)} />
        ) : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    tasks: state.tasks || List(),
    tasksLoading: state.tasksLoading,
    tasksError: state.tasksError,
    adding: state.orderTaskCreating,
    editing: state.orderTaskEditing,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTasks: config => dispatch(fetchTasks(config)),
    addTask: (add = true) => dispatch({ type: 'ORDER_CREATE_TASK', add }),
    editTask: id => dispatch({ type: 'ORDER_EDIT_TASK', id }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderTasks)
